import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import axiosInstance from '../utils/axiosInstance';
import '../assets/css/modal.css'; // Unified modal CSS

const SquareMgmtModal = ({
    isOpen,
    onClose,
    selectedSquare,
    onUpdate,
}) => {
    const [playerName, setPlayerName] = useState('');
    const [userName, setUserName] = useState('');
    const [email, setEmail] = useState('');
    const [players, setPlayers] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchPlayers = async () => {
            try {
                const response = await axiosInstance.get('/players');
                setPlayers(response.data);
            } catch (error) {
                console.error('Error fetching players:', error);
            }
        };

        if (isOpen) {
            fetchPlayers();
            if (selectedSquare) {
                setPlayerName(selectedSquare.playerName || '');
                setUserName(selectedSquare.purchaserName || '');
                setEmail(selectedSquare.purchaserEmail || '');
            }
            setErrors({});
        }
    }, [isOpen, selectedSquare]);

    const validateForm = () => {
        const newErrors = {};
        if (!playerName) newErrors.playerName = 'Please select a player.';
        if (!userName) newErrors.userName = 'Please enter the purchaser name.';
        if (!email) {
            newErrors.email = 'Please enter an email.';
        } else if (!validateEmail(email)) {
            newErrors.email = 'Please enter a valid email address.';
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSave = async () => {
        if (!validateForm()) return;

        setLoading(true);
        try {
            await axiosInstance.put(`/squares/${selectedSquare._id}`, {
                playerName,
                purchaserName: userName,
                purchaserEmail: email,
            });
            onUpdate(); // Refresh squares
            onClose();
        } catch (error) {
            console.error('Error saving square:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleReset = () => {
        setPlayerName('');
        setUserName('');
        setEmail('');
    };

    if (!selectedSquare) return null;

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            overlayClassName="modal-overlay"
            className="modal-content squaremgmt"
        >
            <div className="modal-header">
                {`Square ID: ${selectedSquare?.id || 'Unlabeled'}`}
                <button className="modal-close" onClick={onClose}>
                    ×
                </button>
            </div>
            <div className="form-group">
                <label htmlFor="player-select">Player</label>
                <select
                    id="player-select"
                    className="modal-input"
                    value={playerName}
                    onChange={(e) => setPlayerName(e.target.value)}
                >
                    <option value="" disabled>
                        -- Select a Player --
                    </option>
                    {players.map((player) => (
                        <option key={player._id} value={player.name}>
                            {player.name}
                        </option>
                    ))}
                </select>
                {errors.playerName && <p className="error-message">{errors.playerName}</p>}
            </div>
            <div className="form-group">
                <label htmlFor="user-name">Purchaser Name</label>
                <input
                    id="user-name"
                    className="modal-input"
                    type="text"
                    placeholder="Enter purchaser name"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                />
                {errors.userName && <p className="error-message">{errors.userName}</p>}
            </div>
            <div className="form-group">
                <label htmlFor="user-email">Purchaser Email</label>
                <input
                    id="user-email"
                    className="modal-input"
                    type="email"
                    placeholder="Enter purchaser email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                {errors.email && <p className="error-message">{errors.email}</p>}
            </div>
            <div className="modal-actions">
                <button className="modal-button" onClick={handleSave} disabled={loading}>
                    {loading ? 'Saving...' : 'Save Changes'}
                </button>
                <button className="modal-button reset-button" onClick={handleReset}>
                    Reset
                </button>
            </div>
        </Modal>
    );
};

export default SquareMgmtModal;